// TSS vite/06 — dp versioning scheme. Newest entry first.
// Type enum: 'feature' | 'fix' | 'improvement' | 'breaking'.

const CHANGELOG = [
    {
        version: 'dp0.1',
        date: '2026-08-01',
        title: 'Inicialización del panel',
        notes: [
            { type: 'feature', text: 'Estructura desde trianametria-template-vite v0.2.0' },
            { type: 'feature', text: 'Login por cookie contra POST /api/v1/auth/login, con doble cookie CSRF' },
            { type: 'feature', text: 'Lista paginada de clientes contra GET /api/v1/admin/clients' },
            { type: 'feature', text: 'Carpeta design/ con los tokens CSS como única salida' },
        ],
    },
];

export default CHANGELOG;
